export default "__VITE_ASSET__2Z9l0lWL__"